import React from 'react';
import classname from 'classnames';
import { feature, features } from '@/utils/feature-verifier';
import Search from '@/componentsDS/Search/index';
import InputPrefixIcon from '@/components/InputPrefixIcon';
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg';
import PropTypes from "prop-types";

const SearchInput = ({ value, onChange, onCancel, placeholder }) => {
  const isNewDesignSystem = feature(features.NEW_DESIGN_SYSTEM);

  return (
    <div
      className={classname({
        'overview__search': !isNewDesignSystem,
      })}
      style={isNewDesignSystem ? { marginTop: '20px', width: '350px' } : {}}
    >
     <div style={{ width: '443px' }}>
		<Search
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onCancel={onCancel}
        />
		</div>
    </div>
  );
};


SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default SearchInput;
